const RECEIVE_OMNI_ACCOUNT = 'src/omniAccountSetting/RECEIVE_OMNI_ACCOUNT' as const;
const START_FETCH = 'src/omniAccountSetting/START_FETCH' as const;
const END_FETCH = 'src/omniAccountSetting/EMD_FETCH' as const;

export default { RECEIVE_OMNI_ACCOUNT, START_FETCH, END_FETCH };
